export default __webpack_public_path__ + "static/floor-plan-featured-image-d2a2be902e46168c11ec0cd394f9bac2.png";